import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearInvalidWarning, setInvalidWarning as setInvalidWarningAction } from '~/state/actions/sessionProcess/actions';

const BASE_WARNINGS_KEY = 'pave_shown_warnings';

export const useInvalidWarning = () => {
  const [isWarningVisible, setIsWarningVisible] = useState(false);
  const invalidWarning = useSelector((state) => state.session.invalidWarning);
  const sessionKey = useSelector((state) => state.session.sessionKey);
  const dispatch = useDispatch();

  // Get the storage key for the current session
  const getStorageKey = () => {
    return `${BASE_WARNINGS_KEY}_${sessionKey}`;
  };

  // Load shown warnings from localStorage
  const getShownWarnings = () => {
    try {
      if (!sessionKey) return {};
      const shown = localStorage.getItem(getStorageKey());
      return shown ? JSON.parse(shown) : {};
    } catch (e) {
      return {};
    }
  };

  // Mark a warning as shown
  const markWarningAsShown = (warningType) => {
    try {
      if (!sessionKey) return;
      const shown = getShownWarnings();
      shown[warningType] = true;
      localStorage.setItem(getStorageKey(), JSON.stringify(shown));
    } catch (e) {
      console.error('Failed to save warning state:', e);
    }
  };

  useEffect(() => {
    if (invalidWarning && sessionKey) {
      const shownWarnings = getShownWarnings();
      if (!shownWarnings[invalidWarning]) {
        setIsWarningVisible(true);
      } else {
        // If warning was already shown, clear it without showing
        dispatch(clearInvalidWarning());
      }
    }
  }, [invalidWarning, sessionKey, dispatch]);

  const handleWarningOk = () => {
    if (invalidWarning) {
      markWarningAsShown(invalidWarning);
    }
    setIsWarningVisible(false);
    dispatch(clearInvalidWarning());
  };

  const setInvalidWarning = (warningType) => {
    dispatch(setInvalidWarningAction(warningType));
  };

  const shouldCheckAPI = () => {
    try {
      if (!sessionKey) return false;
      const shown = localStorage.getItem(getStorageKey());
      return !!JSON.parse(shown) ? false : true;
    } catch (e) {
      return false;
    }
  }

  return {
    isWarningVisible,
    invalidWarning,
    handleWarningOk,
    setInvalidWarning,
    shouldCheckAPI,
  };
}; 